import React, { useContext, useMemo, useCallback } from 'react'
import Clickable from 'components/Common/Clickable'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineEditAltIcon from 'components/Luxkit/Icons/line/LineEditAltIcon'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import { SEARCH_VERTICALS } from 'constants/search'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import { useAppSelector } from 'hooks/reduxHooks'
import { arrayToObject } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import styled from 'styled-components'

const EditContainer = styled(Clickable)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: ${rem(24)};
`

const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  row-gap: ${rem(2)};
`

interface Props {
  className?: string;
}

function ExperienceSearchBar({ className }:Props) {
  const { toggleSearchVertical } = useGlobalSearchURLHashVertical()

  const openSearchDrawer = useCallback(() => { toggleSearchVertical(SEARCH_VERTICALS.EXPERIENCES) }, [toggleSearchVertical])
  const categories = useAppSelector(state => state.experience.experienceCategories)
  const { searchItem, experienceCategories } = useContext(GlobalSearchStateContext)

  const selectedCategoryNames = useMemo(() => {
    const categoriesById = arrayToObject(categories, cat => cat.id)
    return experienceCategories?.map(id => categoriesById[id]?.name).filter(Boolean).join(', ')
  }, [categories, experienceCategories])

  return <EditContainer onClick={openSearchDrawer} className={className}>
    <DetailsSection>
      {searchItem && <Heading variant="heading6">{searchItem.format.mainText}</Heading>}
      {!!experienceCategories?.length && <Caption wrap="truncate" variant="large">
        {selectedCategoryNames}
      </Caption>}
    </DetailsSection>
    <TextButton kind="tertiary" endIcon={<LineEditAltIcon />} nonInteractable>Edit</TextButton>
  </EditContainer>
}

export default ExperienceSearchBar
